import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { mountComponent } from '../util/mount';
import {
    IMAGE_HEADER_SUBLINE_CLASSNAME,
    ImageHeader,
    createImageHeader,
} from '@vfde-brix/ws10/image-header';
import { getImageHeaderData } from '../util/cms';
import { HtmlId } from 'app/enums/elementId';

/**
 * Read the ImageHeader's subline element from the DOM
 *
 * @param {ImageHeader} comp - ImageHeader component
 * @returns {Element | null} - Subline element
 */
const getSublineElement = (comp: ImageHeader) =>
    comp.getContainerElement()
        .getElementsByClassName(IMAGE_HEADER_SUBLINE_CLASSNAME)[0]
        .firstElementChild;

/**
 * Create Brix imageHeader component.
 *
 * @param id ID of the button element.
 */
export const mountImageHeader = (id: HtmlId) =>
    mountComponent(id, createImageHeader, NO_PATTERN_BUSINESS_LOGIC);

/**
 * updateImageHeader
 * Update the image header based on the product availability result
 *
 * @param {ImageHeader | null} comp - component to update
 * @param {JarvisSuggestionType} type - jarvis product suggestion type
 */
export const updateImageHeader = (comp: ImageHeader | null, isYoung: boolean, cableMax1000: boolean) => {
    const config = getImageHeaderData(cableMax1000, isYoung);

    if (!comp || !config) {
        return;
    }

    const props = comp.getProperties();
    const sublineOriginalClass = getSublineElement(comp)?.className;

    props.stdImgSrcDesktop = config.imageDesktop;
    props.stdImgSrcMobile = config.imageMobile;

    if (props.containerHeadline) {
        props.containerHeadline.stdContent = config.headline;
    }

    if (props.containerSubline) {
        if ('content' in props.containerSubline) {
            props.containerSubline.content = config.subline;
        }

        if ('stdContent' in props.containerSubline) {
            props.containerSubline.stdContent = config.subline;
        }
    }

    props.containerHighlightBadge = config.flagBadge
        ? {
            business: NO_PATTERN_BUSINESS_LOGIC,
            optColor: config.flagBadge.color,
            optSize: 'standard',
            txtContent: config.flagBadge.text,
        } : undefined;

    comp.update(props);

    // Re-apply original styles after update because of brix bug
    const subline = getSublineElement(comp);

    if (subline && sublineOriginalClass) {
        subline.className = sublineOriginalClass;
    }
};
